exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-hide[data-v-3cc1d18b]{text-decoration:none}", ""]);

// exports
